if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.setSendOnDateBounds();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;
      static MAX_SEND_ON_DAYS = 90;
      static EMOJI_SHORTCODES = {
        smile: '😄',
        smiley: '😃',
        grinning: '😀',
        grin: '😁',
        laugh: '😆',
        laughing: '😆',
        satisfied: '😆',
        sweat_smile: '😅',
        joy: '😂',
        rofl: '🤣',
        blush: '😊',
        innocent: '😇',
        wink: '😉',
        winking_face: '😉',
        slightly_smiling_face: '🙂',
        upside_down_face: '🙃',
        heart_eyes: '😍',
        star_struck: '🤩',
        kissing_heart: '😘',
        kissing: '😗',
        kissing_smiling_eyes: '😙',
        kissing_closed_eyes: '😚',
        yum: '😋',
        stuck_out_tongue: '😛',
        stuck_out_tongue_winking_eye: '😜',
        stuck_out_tongue_closed_eyes: '😝',
        thinking: '🤔',
        hugging_face: '🤗',
        hug: '🤗',
        smirk: '😏',
        sunglasses: '😎',
        nerd_face: '🤓',
        zipper_mouth_face: '🤐',
        rolling_eyes: '🙄',
        grimacing: '😬',
        relieved: '😌',
        pensive: '😔',
        sleepy: '😪',
        sleeping: '😴',
        disappointed: '😞',
        worried: '😟',
        cry: '😢',
        sob: '😭',
        fearful: '😨',
        weary: '😩',
        exploding_head: '🤯',
        scream: '😱',
        flushed: '😳',
        zany_face: '🤪',
        dizzy_face: '😵',
        rage: '😡',
        angry: '😠',
        face_with_symbols_on_mouth: '🤬',
        mask: '😷',
        sneeze: '🤧',
        sneezing_face: '🤧',
        hot_face: '🥵',
        cold_face: '🥶',
        waving_hand: '👋',
        wave: '👋',
        clap: '👏',
        raised_hands: '🙌',
        pray: '🙏',
        muscle: '💪',
        ok_hand: '👌',
        v: '✌️',
        '+1': '👍',
        thumbsup: '👍',
        thumbs_up: '👍',
        '-1': '👎',
        thumbsdown: '👎',
        thumbs_down: '👎',
        heart: '❤️',
        yellow_heart: '💛',
        green_heart: '💚',
        blue_heart: '💙',
        purple_heart: '💜',
        black_heart: '🖤',
        white_heart: '🤍',
        orange_heart: '🧡',
        broken_heart: '💔',
        sparkling_heart: '💖',
        two_hearts: '💕',
        heartbeat: '💓',
        gift: '🎁',
        tada: '🎉',
        balloon: '🎈',
        sparkles: '✨',
        star: '⭐',
        fire: '🔥',
        100: '💯',
        boom: '💥',
        zap: '⚡',
        sunshine: '☀️',
        sunny: '☀️',
        rainbow: '🌈',
        rose: '🌹',
        hibiscus: '🌺',
        sunflower: '🌻',
        bouquet: '💐',
        cake: '🎂',
        cupcake: '🧁',
        coffee: '☕',
        beer: '🍺',
        wine_glass: '🍷',
        pizza: '🍕',
        kiss: '💋',
        love_letter: '💌',
        ribbon: '🎀',
        party: '🥳',
        partying_face: '🥳',
        hugs: '🤗',
        eyes: '👀',
        see_no_evil: '🙈',
        hear_no_evil: '🙉',
        speak_no_evil: '🙊',
        poop: '💩',
        sweat_drops: '💦',
        dash: '💨',
        check: '✅',
        x: '❌',
        warning: '⚠️',
        question: '❓',
        exclamation: '❗',
        heavy_heart_exclamation: '❣️',
      };

      /**
       * Restricts Send on to today through Shopify's 90-day schedule limit.
       */
      setSendOnDateBounds() {
        if (!this.sendonInput) return;

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const today = new Date();
        const maxDate = new Date(today);
        maxDate.setDate(maxDate.getDate() + this.constructor.MAX_SEND_ON_DAYS);

        const min = formatDate(today);
        const max = formatDate(maxDate);

        this.sendonInput.min = min;
        this.sendonInput.max = max;

        if (this.sendonInput.value && (this.sendonInput.value < min || this.sendonInput.value > max)) {
          this.sendonInput.value = '';
        }
      }

      connectedCallback() {
        this.onMessageInput = this.convertMessageShortcodes.bind(this);
        this.messageInput?.addEventListener('input', this.onMessageInput);
        this.messageInput?.addEventListener('blur', this.onMessageInput);
        this.convertMessageShortcodes();

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          }
        );

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        this.messageInput?.removeEventListener('input', this.onMessageInput);
        this.messageInput?.removeEventListener('blur', this.onMessageInput);

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      /**
       * Turns Slack/GitHub shortcodes (:smile:) into emoji so the cart
       * property and Shopify gift-card email store the actual character.
       */
      convertMessageShortcodes() {
        const textarea = this.messageInput;
        if (!textarea) return;

        const { EMOJI_SHORTCODES } = this.constructor;
        const selectionStart = textarea.selectionStart;
        const beforeCursor = textarea.value.slice(0, selectionStart);
        const afterCursor = textarea.value.slice(selectionStart);

        const replaceShortcodes = (text) =>
          text.replace(/:([a-z0-9_+-]+):/gi, (match, name) => EMOJI_SHORTCODES[name.toLowerCase()] ?? match);

        const convertedBefore = replaceShortcodes(beforeCursor);
        const convertedValue = convertedBefore + replaceShortcodes(afterCursor);

        if (convertedValue === textarea.value) return;

        textarea.value = convertedValue;
        const cursor = convertedBefore.length;
        textarea.setSelectionRange(cursor, cursor);
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = FoxTheme.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = FoxTheme.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.setSendOnDateBounds();
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}
